import { render, staticRenderFns } from "./management-edition-rules.component.vue?vue&type=template&id=5f5a74f8&scoped=true&"
import script from "./management-edition-rules.component.vue?vue&type=script&lang=ts&"
export * from "./management-edition-rules.component.vue?vue&type=script&lang=ts&"
import style0 from "./management-edition-rules.component.vue?vue&type=style&index=0&id=5f5a74f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a74f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VForm,VIcon,VSpacer,VTextField})
